const trainHealthGridletModule = {
  bindings: {
    view: '<',
    settings: '<',
  },
  templateUrl: '/modules/gridlets/dashboard/train-health-gridlet/train-health-gridlet-module.html',
  controller: 'TrainHealthGridletController',
};

angular
  .module('dashboardGridletDirectives')
  .component('trainHealthGridletModule', trainHealthGridletModule);
